module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/BC3049-4552b2c5714d1962133c0a2de52584c3.png";